import { useEffect, useRef } from 'preact/hooks';

import { api } from '../api.js';

// Realtime in de webapp (sprint 4): één EventSource op /v1/app/live; elke poke (change_log van
// het huishouden, ook van de kiosk of de telefoon van de ander) laat de pagina opnieuw laden.
// Kort gebundeld zodat een reeks wijzigingen één verversing geeft. De server sluit de stream na
// 25 min; EventSource verbindt vanzelf opnieuw.

const DEBOUNCE_MS = 250;

export function useLive(onPoke: () => void, enabled = true): void {
  const cb = useRef(onPoke);
  cb.current = onPoke;
  useEffect(() => {
    if (!enabled || typeof EventSource === 'undefined') return undefined;
    const source = new EventSource(api.app.food.liveUrl());
    let timer: ReturnType<typeof setTimeout> | null = null;
    const onEvent = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => cb.current(), DEBOUNCE_MS);
    };
    source.addEventListener('poke', onEvent);
    return () => {
      if (timer) clearTimeout(timer);
      source.removeEventListener('poke', onEvent);
      source.close();
    };
  }, [enabled]);
}
